import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import './dehydration.css';
import ModalTrigger from '../../../shared/modal/ModalTrigger';

type DehydrationProps = {
  assessmentValues: Record<string, string>;
  questionid: string;
  questionTitle: string;
  questionTitleSuffix?: string;
  modalText?: string;
  width: string;
  onOpenModal?: () => void;
  onSetValue: (value: { id: string; value: string }) => void;
};

export function Dehydration({
  assessmentValues,
  questionid,
  questionTitle,
  questionTitleSuffix,
  modalText,
  width,
  onOpenModal,
  onSetValue,
}: DehydrationProps) {
  const { t } = useTranslation();
  const rows = [
    { index: 0, value: 1, description: t('A145') },
    { index: 1, value: 2, description: t('A146') },
    { index: 2, value: 3, description: t('A147') },
    { index: 3, value: 4, description: t('A148') },
    { index: 4, value: 5, description: t('A149') },
    { index: 5, value: 6, description: t('A150') },
    { index: 6, value: 7, description: t('A151') },
    { index: 7, value: 8, description: t('A152') },
  ];

  const [radioOption, setRadioOption] = useState<number | undefined>();

  function saveValue(event) {
    const { value } = event.target;
    if (!value) return;
    setRadioOption(value);
    onSetValue({ id: questionid, value });
  }

  useEffect(() => {
    if (assessmentValues[questionid] && !radioOption) {
      setRadioOption(Number(assessmentValues[questionid]));
    }
  }, [assessmentValues, questionid, radioOption]);

  return (
    <div className={`req question_block${width}`}>
      <fieldset id={questionid} data-input-type="dehydration">
        <legend className="assessment_question_title">{questionTitle}</legend>
        {questionTitleSuffix ? <span className="titleSuffix">{questionTitleSuffix}</span> : null}
        {modalText && (
          <ModalTrigger
            modalText={modalText}
            onOpenModal={onOpenModal}
            question={questionid}
            questionTitle={questionTitle}
          />
        )}
        <div className="answer_block fs-exclude">
          <div className={`dot_radio dehydration ${questionid}`} id={questionid}>
            {rows.map((option) => {
              const checked = String(radioOption) === String(option.value);
              return (
                <div className="input_wrap" key={option.index}>
                  <input
                    type="radio"
                    id={questionid + option.value}
                    name={questionid}
                    value={option.value}
                    onChange={(e) => {
                      e.stopPropagation();
                      saveValue(e);
                    }}
                    checked={checked}
                  />
                  <label
                    htmlFor={questionid + option.value}
                    id={`${questionid}_${option.value}_label`}
                    className="dehydration-label"
                  >
                    <span className="visuallyHidden">{option.description}</span>
                    <div className="dehydration-option-content">
                      <div className="dehydration-dot" />
                      <span className="dehydration-text">{option.description}</span>
                    </div>
                  </label>
                </div>
              );
            })}
          </div>
        </div>
      </fieldset>
    </div>
  );
}
